import { IUser } from 'root/models';
import { crudMutations, CRUDState, ICRUDState } from 'root/store/helpers';
// import { MutationTypeUser } from './types';

export interface IUserState extends ICRUDState<IUser> {
}

export const defaultState: IUserState = {
  ...CRUDState(),
};

export const mutations = {
  ...crudMutations('user')
};
